import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Footer from './Footer';

const COMPANY = {
  name: 'SC MIRICOS BISTRO SRL',
  brand: 'Garden8',
  cui: 'RO 51428096',
  regCom: 'J2025017256004',
  sediu: 'Calea Odobești nr. 6, com. Câmpineanca, jud. Vrancea',
  pdl: 'Bd. Dimitrie Pompeiu nr. 8, Sector 2, București',
  email: 'garden8.pipera@gmail.com',
  phone: '0731 156 700',
};

const CANCEL_HOUR = '11:00';

const PAGES = {
  livrare: {
    title: 'Livrare & Ridicare',
    body: (
      <>
        <p>
          <strong>{COMPANY.brand}</strong> este o cantină cu servicii de pre-comandă și ridicare. Nu efectuăm livrări la domiciliu.
          Toate comenzile plasate prin platforma <a href="https://meniu-garden8.ro">meniu-garden8.ro</a> se ridică personal de la punctul nostru de lucru.
        </p>
        <h2>Adresa de ridicare</h2>
        <p>{COMPANY.pdl}</p>
        <h2>Program de ridicare</h2>
        <ul>
          <li>Luni – Vineri, între orele <strong>12:30 – 18:00</strong></li>
          <li>Sâmbătă, Duminică și sărbători legale: închis</li>
        </ul>
        <h2>Intervale de ridicare</h2>
        <p>
          La finalizarea comenzii vei alege un interval de 30 min (ex: 12:30–13:00, 13:00–13:30, etc.).
          Un slot de ridicare este disponibil numai dacă începe la cel puțin <strong>60 de minute</strong> după momentul plasării comenzii,
          pentru a permite timpul minim de pregătire de aproximativ <strong>20 minute</strong>.
        </p>
        <h2>Notificare de întârziere</h2>
        <p>
          În cazuri excepționale (volum mare, indisponibilitate temporară a ingredientelor), te vom notifica prin email cu privire la o eventuală întârziere,
          înainte de intervalul ales. Poți vedea în orice moment statusul comenzii accesând link-ul din emailul de confirmare.
        </p>
      </>
    ),
  },
  retur: {
    title: 'Retur & Anulare Comandă',
    body: (
      <>
        <p>
          Produsele comercializate prin <a href="https://meniu-garden8.ro">meniu-garden8.ro</a> sunt <strong>alimente preparate           personalizat, perisabile</strong>, conform Ordonanței de Urgență a Guvernului nr. 34/2014 art. 16 lit. d) — motiv pentru care <strong>nu se aplică dreptul de retragere</strong> de 14 zile.
        </p>
        <h2>Anulare gratuită</h2>
        <p>
          Comenzile plătite online pot fi anulate <strong>gratuit</strong> până la ora <strong>{CANCEL_HOUR}</strong> a zilei de ridicare selectate.
          După această oră, comenzile intră în producție și nu mai pot fi anulate sau returnate, deoarece produsele sunt preparate personalizat.
        </p>
        <h2>Cum anulezi</h2>
        <p>
          Trimite o cerere de anulare pe adresa <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a> înainte de ora {CANCEL_HOUR},
          menționând: numele complet, numărul de telefon și data ridicării. Vei primi confirmare de anulare în cel mult 30 minute și rambursarea integrală
          se va procesa automat pe cardul folosit la plată, în termen de <strong>3–14 zile lucrătoare</strong> (în funcție de banca emitentă).
        </p>
        <h2>Neconformități la ridicare</h2>
        <p>
          Dacă la ridicare constați că un produs este necorespunzător (temperatură, aspect, ambalaj), te rugăm să anunți imediat personalul de la punctul de lucru.
          Vom înlocui produsul sau vom rambursa contravaloarea acestuia, la alegerea ta.
        </p>
        <h2>Reclamații</h2>
        <p>
          Orice reclamație se trimite pe email la <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>.
          Răspundem în maximum 5 zile lucrătoare. Pentru soluționarea alternativă a litigiilor poți accesa portalul ANPC —{' '}
          <a href="https://anpc.ro/ce-este-sal/" target="_blank" rel="noopener noreferrer">anpc.ro/ce-este-sal</a>.
        </p>
      </>
    ),
  },
  termeni: {
    title: 'Termeni și Condiții',
    body: (
      <>
        <p>
          Prin utilizarea platformei <a href="https://meniu-garden8.ro">meniu-garden8.ro</a>, operată de {COMPANY.name} (denumită în continuare &bdquo;Vânzătorul&rdquo;), confirmi că ai citit, ai înțeles și ești de acord cu termenii de mai jos.
        </p>
        <h2>1. Obiectul contractului</h2>
        <p>
          Vânzătorul oferă spre pre-comandă produse alimentare preparate în cantina proprie, ridicarea acestora făcându-se personal, la punctul de lucru menționat.
          Prețurile afișate sunt exprimate în lei (RON) și includ TVA-ul aplicabil.
        </p>
        <h2>2. Plasarea comenzii</h2>
        <p>
          Pentru a plasa o comandă, clientul selectează produsele dorite, alege ziua și intervalul de ridicare, introduce datele de contact (nume, telefon, email opțional)
          și finalizează plata online prin procesatorul Stripe. Comanda este considerată plasată doar după confirmarea plății.
        </p>
        <h2>3. Prețuri și plată</h2>
        <p>
          Singura metodă de plată acceptată este plata online cu cardul, prin procesatorul Stripe (Visa, Mastercard, Apple Pay, Google Pay).
          Nu acceptăm plata cash sau card la ridicare.
        </p>
        <h2>4. Livrare / Ridicare</h2>
        <p>Consultă secțiunea <Link to="/livrare">Livrare</Link>.</p>
        <h2>5. Retur și anulare</h2>
        <p>Consultă secțiunea <Link to="/retur">Retur & Anulare</Link>.</p>
        <h2>6. Răspundere</h2>
        <p>
          Vânzătorul răspunde pentru calitatea produselor livrate la data și ora ridicării. Vânzătorul nu răspunde pentru degradarea produselor cauzată de neridicarea
          acestora în intervalul selectat sau de manipularea/depozitarea necorespunzătoare după ridicare.
        </p>
        <h2>7. Proprietate intelectuală</h2>
        <p>
          Toate elementele grafice, textele și structura platformei aparțin {COMPANY.name} și sunt protejate de legislația română privind drepturile de autor.
          Reproducerea neautorizată este interzisă.
        </p>
        <h2>8. Modificări</h2>
        <p>
          Ne rezervăm dreptul de a modifica acești termeni în orice moment. Versiunea în vigoare este cea afișată pe site la momentul plasării comenzii.
        </p>
        <h2>9. Legea aplicabilă</h2>
        <p>
          Contractul este guvernat de legea română. Orice litigiu se va soluționa amiabil, iar în caz de eșec, prin instanțele competente de la sediul Vânzătorului sau prin ANPC ({' '}
          <a href="https://anpc.ro/ce-este-sal/" target="_blank" rel="noopener noreferrer">SAL</a>).
        </p>
      </>
    ),
  },
  gdpr: {
    title: 'Politică de Confidențialitate (GDPR)',
    body: (
      <>
        <p>
          {COMPANY.name}, în calitate de operator de date, prelucrează datele personale ale clienților în conformitate cu Regulamentul (UE) 2016/679 (GDPR).
        </p>
        <h2>1. Ce date colectăm</h2>
        <ul>
          <li>Nume și prenume</li>
          <li>Număr de telefon</li>
          <li>Adresă de email (opțional, pentru notificări de comandă)</li>
          <li>Detalii comandă (produse, sumă, dată, interval ridicare)</li>
          <li>Datele plății sunt procesate direct de Stripe — noi <strong>nu stocăm date de card</strong></li>
        </ul>
        <h2>2. Scopul prelucrării</h2>
        <ul>
          <li>Procesarea comenzilor și livrarea produselor</li>
          <li>Trimiterea confirmării de comandă și a notificărilor de status (via Resend)</li>
          <li>Îndeplinirea obligațiilor legale (fiscale, contabile)</li>
        </ul>
        <h2>3. Cât timp păstrăm datele</h2>
        <p>
          Datele comenzilor sunt păstrate 10 ani conform legislației fiscale române. Datele de contact pot fi șterse la cererea ta oricând, dacă nu sunt necesare pentru
          o comandă în curs.
        </p>
        <h2>4. Drepturile tale</h2>
        <ul>
          <li>Dreptul de acces la datele tale</li>
          <li>Dreptul la rectificare</li>
          <li>Dreptul la ștergere (&quot;dreptul de a fi uitat&quot;)</li>
          <li>Dreptul la restricționarea prelucrării</li>
          <li>Dreptul la portabilitatea datelor</li>
          <li>Dreptul de opoziție</li>
        </ul>
        <p>
          Pentru a-ți exercita aceste drepturi, trimite o cerere pe email la <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>.
          Vom răspunde în maximum 30 de zile.
        </p>
        <h2>5. Furnizori terți (procesatori de date)</h2>
        <ul>
          <li><strong>Stripe</strong> — procesare plăți online (date de card, valoare tranzacție)</li>
          <li><strong>Resend (Amazon SES)</strong> — trimitere emailuri tranzacționale</li>
          <li><strong>Emergent</strong> — găzduire aplicație</li>
        </ul>
        <h2>6. Cookies</h2>
        <p>
          Site-ul folosește doar cookie-uri strict necesare pentru funcționare (sesiune, coș). Nu folosim cookie-uri de marketing sau tracking.
        </p>
        <h2>7. Autoritatea de supraveghere</h2>
        <p>
          Dacă consideri că drepturile îți sunt încălcate, poți depune plângere la Autoritatea Națională de Supraveghere a Prelucrării Datelor cu Caracter Personal (ANSPDCP) — {' '}
          <a href="https://www.dataprotection.ro" target="_blank" rel="noopener noreferrer">dataprotection.ro</a>.
        </p>
      </>
    ),
  },
  contact: {
    title: 'Contact & Date Companie',
    body: (
      <>
        <h2>Date de identificare</h2>
        <ul>
          <li><strong>Denumire:</strong> {COMPANY.name}</li>
          <li><strong>CUI:</strong> {COMPANY.cui}</li>
          <li><strong>Nr. Registrul Comerțului:</strong> {COMPANY.regCom}</li>
          <li><strong>Sediu social:</strong> {COMPANY.sediu}</li>
          <li><strong>Punct de lucru (cantină):</strong> {COMPANY.pdl}</li>
        </ul>
        <h2>Date de contact</h2>
        <ul>
          <li><strong>Email:</strong> <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a></li>
          <li><strong>Telefon:</strong> <a href={`tel:+40731156700`}>{COMPANY.phone}</a></li>
        </ul>
        <h2>Program de lucru</h2>
        <p>Luni – Vineri, 12:30 – 18:00. Închis sâmbăta, duminica și de sărbători legale.</p>
        <h2>ANPC — Soluționarea alternativă a litigiilor</h2>
        <p>
          Pentru soluționarea alternativă a litigiilor, accesează portalul ANPC:{' '}
          <a href="https://anpc.ro/ce-este-sal/" target="_blank" rel="noopener noreferrer">anpc.ro/ce-este-sal</a>{' '}
          sau consultă legislația aplicabilă la{' '}
          <a href="https://legislatie.just.ro/Public/DetaliiDocument/257649?fs=e&s=cl" target="_blank" rel="noopener noreferrer">
            legislatie.just.ro
          </a>.
        </p>
      </>
    ),
  },
};

const LegalPage = ({ slug }) => {
  const location = useLocation();
  const key = slug || location.pathname.replace('/', '');
  const page = PAGES[key];

  if (!page) {
    return (
      <div className="legal-page-wrap">
        <div className="legal-page">
          <p>Pagina nu a fost găsită.</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="legal-page-wrap">
        <div className="legal-page">
          <Link to="/" className="legal-back" data-testid="legal-back">
            <ArrowLeft className="w-4 h-4" />
            Înapoi la meniu
          </Link>
          <h1>{page.title}</h1>
          <div className="legal-content">{page.body}</div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default LegalPage;
